var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.43,16.92l-.77-.64c.46-.55,.72-1.25,.72-1.97,0-.63-.19-1.24-.55-1.75-.52-.69-.8-1.54-.8-2.42,0-2.25,1.83-4.07,4.07-4.07s4.07,1.83,4.07,4.07-1.83,4.07-4.07,4.07v-1c1.7,0,3.07-1.38,3.07-3.07s-1.38-3.07-3.07-3.07-3.07,1.38-3.07,3.07c0,.67,.21,1.3,.61,1.84,.48,.7,.74,1.5,.74,2.34,0,.96-.34,1.89-.95,2.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.89,21.18c-1.51,0-2.95-.65-3.94-1.8l1.13-.98c.71,.81,1.73,1.28,2.81,1.28,1.48,0,2.83-.88,3.42-2.24,.01-.04,.05-.12,.08-.21,.39-.89,1.02-1.65,1.83-2.21l.23-.16c.29-.21,.56-.46,.81-.72,1.02-1.08,1.58-2.5,1.58-3.99,0-3.22-2.62-5.83-5.83-5.83s-5.83,2.62-5.83,5.83h-1.5c0-4.04,3.29-7.33,7.33-7.33s7.33,3.29,7.33,7.33c0,1.87-.7,3.65-1.98,5.01-.3,.33-.65,.63-1.02,.9l-.2,.14c-.65,.44-1.1,.99-1.37,1.62-.03,.06-.05,.11-.06,.16-.85,1.95-2.73,3.18-4.81,3.18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarIcon);
export default __webpack_public_path__ + "static/media/Ear-Icon.4da09495edf3dbed329b98b7ec7937bc.svg";
export { ForwardRef as ReactComponent };